import { IPayment } from "types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all payments
export const getPayments = async () => {
  return axios
    .get(ServiceEndpoints.PAYMENT) 
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new payment
export const createPayment = async (data: IPayment) => {
  return axios
    .post(ServiceEndpoints.PAYMENT, data) 
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing payment
export const updatePayment = async (id: string, data: IPayment) => {
  const { ...paymentData } = data;

  return axios
    .put(`${ServiceEndpoints.PAYMENT}/${id}`, paymentData) 
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a payment by its ID
export const getPaymentById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.PAYMENT}/${id}`) 
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a payment
export const deletePayment = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.PAYMENT}/${id}`) 
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
